import { Button } from '@abdt/ornament';

const TextButton = (props) => {
  return (
    <Button variant="text" size='large' {...props} />
  );
};

export default TextButton;
